import { useState, useEffect } from "react";
import { Form, Button, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { checkUpdateTime, fetchPersonalData, UrlSave } from "./method"
import Swal from "sweetalert2";
import "../../assets/css/pin.css";
import Encryptor from "../../utils/Encryptor.js";

export default function Index() {

    const navigate = useNavigate();

    const [rut] = useState(localStorage.getItem("idPersona"));
    const [disabled] = useState(true);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({
        rut: "",
        phone: "",
        hasEmail: true,
        email: "",
        repitEmail: "",
        password: "",
        isEnrolled: false,
        link: "",
        image: "",
        updateMail: false,
        updatePhone: false,
    });

    const phoneIsInvalid = (telefono) => !/^\d{9}$/.test(telefono);

    useEffect(() => {
        async function fetchData() {
            setLoading(true);
            try {
                const responseFetchPersonalData = await fetchPersonalData(rut);

                const response = responseFetchPersonalData.resultado?.wmTraerDatosPersonalesResponse?.wmTraerDatosPersonalesResult?.diffgram?.NewDataSet?.DATA;

                if (!response) {
                    throw new Error("La respuesta no contiene datos válidos.");
                }

                if (response.HEADER !== "AU00") {
                    Swal.fire({
                        icon: "warning",
                        text: response.MESSAGE || "Error desconocido al obtener datos.",
                        confirmButtonText: "Ok",
                        allowOutsideClick: false
                    });
                    return;
                }

                const celularStr = response.Celular?.toString() || "";
                let celularFinal = celularStr.length > 9 ? celularStr.slice(-9) : celularStr;
                // Si el teléfono tiene 8 dígitos, agregar el 9 al inicio
                if (celularFinal.length === 8) {
                    celularFinal = '9' + celularFinal;
                }

                setData((prevData) => ({
                    ...prevData,
                    rut: rut,
                    phone: celularFinal,
                    email: response.Email,
                    repitEmail: response.Email,
                    hasEmail: true
                }));
            } catch (error) {
                console.error("Error al obtener datos personales:", error);
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "Ocurrió un error al obtener los datos. Inténtalo nuevamente.",
                    confirmButtonText: "Ok",
                    customClass: {
                        confirmButton: "btn btn-success",
                        cancelButton: "btn btn-danger",
                    },
                    allowOutsideClick: false
                });
            } finally {
                setLoading(false);
            }
        }

        fetchData();
    }, [rut]);

    const emailIsValid = (email) => {
        const re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        return re.test(email);
    };

    const isFormValid = () => {
        const isPhoneValid = !phoneIsInvalid(data.phone);
        const isEmailValid = emailIsValid(data.email);
        const isRepitEmailValid = data.email === data.repitEmail && emailIsValid(data.repitEmail);

        return isPhoneValid && isEmailValid && isRepitEmailValid;
    };

    const handleConfirmData = async (e) => {
        e.preventDefault();
        setLoading(true);

        if (!isFormValid()) {
            Swal.fire({
                icon: "warning",
                text: "Por favor, complete todos los campos correctamente.",
                confirmButtonText: "Ok",
                allowOutsideClick: false
            });
            setLoading(false);
            return;
        }

        try {
            // Siempre forzamos la validación de PIN independientemente del tiempo transcurrido
            const updateData = { 
                ...data, 
                updateMail: true, 
                updatePhone: true, 
                hasEmail: true 
            };
            
            const saveResponse = await UrlSave(updateData);

            const crypto = new Encryptor();
            const encrypted = crypto.encrypt(saveResponse.id);

            // Siempre ir a la validación de PIN
            navigate(`/pin/send/${encrypted}`);
        } catch (error) {
            console.error("Error al guardar datos:", error);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Ocurrió un error al procesar los datos. Inténtalo nuevamente.",
                confirmButtonText: "Ok",
                allowOutsideClick: false
            });
        } finally {
            setLoading(false);
        }
    };

    const handleModifyData = async () => {
        var response = await checkUpdateTime(rut);

        if (response.resultado.codigo === "AU00") {
            data.updateMail = response.resultado.mensaje.includes("Han pasado mas de 365 dias sin actualizar el MAIL");
            data.updatePhone = response.resultado.mensaje.includes("Han pasado mas de 365 dias sin actualizar el TELEFONO");
        }
        
        navigate("/pin/login", { state: { data: data } });
    };

    const handleGoBack = () => {
        navigate("/paet/formaPago");
    };

    const handleInputChange = (field, value) => {
        setData((prevData) => ({ ...prevData, [field]: value }));
    };

    return (
        <div className="container">
            <div className="card formulario pin mt-5 mb-5">
                <div className="card-header">
                    <div className="form-row">
                        <div className="titulo">
                            Formulario de Retiro de Pensión Anticipada por Enfermedad Terminal
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="subtitulo mt-3">
                            Confirmación datos de contacto
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="subtitulo-2 mt-3">
                            Estos datos serán los utilizados para notificarte sobre el avance de tu solicitud.
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <Form onSubmit={handleConfirmData}>
                        {/* Phone Number Field */}
                        <div className="form-row">
                            <div className="form-group col-md-12">
                                <Form.Label htmlFor="phone" className="col-form-label">
                                    <strong className="asterisco">*</strong> Telefóno
                                </Form.Label>
                                <Form.Control
                                    name="phone"
                                    type="tel"
                                    maxLength={9}
                                    placeholder="912345678"
                                    value={data.phone}
                                    disabled={disabled}
                                    onChange={(e) => {
                                        const value = e.target.value.replace(/\D/g, '');
                                        if (value.length <= 9) {
                                            handleInputChange("phone", value);
                                        }
                                    }}
                                    isInvalid={phoneIsInvalid(data.phone)}
                                    isValid={!phoneIsInvalid(data.phone)}
                                />
                                <Form.Control.Feedback type="invalid">
                                    Por favor, ingrese telefóno válido.
                                </Form.Control.Feedback>
                            </div>
                        </div>

                        {/* Email always required - checkbox removed */}

                        {/* Email Fields */}
                        {/* Email Fields (always shown) */}
                        <>
                                <div className="form-row">
                                    <div className="form-group col-md-12">
                                        <Form.Label htmlFor="email" className="col-form-label">
                                            <strong className="asterisco">*</strong> Correo
                                        </Form.Label>
                                        <Form.Control
                                            name="email"
                                            type="email"
                                            placeholder="pablo*****"
                                            value={data.email}
                                            maxLength={50}
                                            disabled={disabled}
                                            onChange={(e) => handleInputChange("email", e.target.value)}
                                            isInvalid={!emailIsValid(data.email)}
                                            isValid={emailIsValid(data.email)}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Por favor, ingrese un correo válido.
                                        </Form.Control.Feedback>
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group col-md-12">
                                        <Form.Label htmlFor="repitEmail" className="col-form-label">
                                            <strong className="asterisco">*</strong> Confirmar correo
                                        </Form.Label>
                                        <Form.Control
                                            name="repitEmail"
                                            type="email"
                                            placeholder="pablo*****"
                                            value={data.repitEmail}
                                            maxLength={50}
                                            disabled={disabled}
                                            onChange={(e) => handleInputChange("repitEmail", e.target.value)}
                                            isInvalid={data.email !== data.repitEmail || !emailIsValid(data.repitEmail)}
                                            isValid={data.email === data.repitEmail && emailIsValid(data.repitEmail)}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {data.repitEmail === "" ? "Por favor, ingresa el correo electrónico de nuevo." : ""}
                                            {data.email !== data.repitEmail ? "Los correos electrónicos no coinciden." : ""}
                                        </Form.Control.Feedback>
                                    </div>
                                </div>
                            </>

                        {/* Buttons */}
                        <div className="mt-4 text-center">
                            <div className="form-group mb-2">
                                <Button
                                    variant="success"
                                    className="col-md-12"
                                    type="submit"
                                    disabled={!isFormValid() || loading}
                                >
                                    {loading ? <Spinner animation="border" variant="light" size="sm" /> : "Confirmar datos"}
                                </Button>
                            </div>

                            <div className="form-group mb-2">
                                <Button
                                    variant="outline-primary"
                                    className="col-md-12"
                                    onClick={handleModifyData}>
                                    Ir a modificar
                                </Button>
                            </div>
                            <div className="form-group mb-2">
                                <Button variant="link" className="col-md-12" onClick={handleGoBack}>
                                    Volver al paso anterior
                                </Button>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
    );
}